import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { DEFAULT_CONFIG } from '../constants';
import { RestClient } from '../rest-client';
var CONTAINER_TYPE = /*#__PURE__*/function (CONTAINER_TYPE) {
  CONTAINER_TYPE["JIRA_PROJECT"] = "jiraProject";
  CONTAINER_TYPE["CONFLUENCE_SPACE"] = "confluenceSpace";
  return CONTAINER_TYPE;
}(CONTAINER_TYPE || {});
var ENTITY_TYPE = /*#__PURE__*/function (ENTITY_TYPE) {
  ENTITY_TYPE["CONTAINER"] = "CONTAINER";
  ENTITY_TYPE["USER"] = "USER";
  return ENTITY_TYPE;
}(ENTITY_TYPE || {});
export var CollaborationGraphClient = /*#__PURE__*/function (_RestClient) {
  _inherits(CollaborationGraphClient, _RestClient);
  var _super = _createSuper(CollaborationGraphClient);
  function CollaborationGraphClient() {
    _classCallCheck(this, CollaborationGraphClient);
    return _super.apply(this, arguments);
  }
  _createClass(CollaborationGraphClient, [{
    key: "getUserContainers",
    value: function getUserContainers(_ref) {
      var userId = _ref.userId,
        principalId = _ref.principalId,
        siteId = _ref.siteId,
        sessionId = _ref.sessionId,
        maxNumberOfResults = _ref.maxNumberOfResults;
      return this.postResource('/v1/collaborationgraph/user/container', {
        context: {
          contextType: 'atlassianDirectory',
          principalId: principalId,
          siteId: siteId,
          sessionId: sessionId
        },
        containerTypes: ['confluenceSpace', 'jiraProject'],
        maxNumberOfResults: maxNumberOfResults,
        userId: userId,
        expanded: true
      });
    }
  }]);
  return CollaborationGraphClient;
}(RestClient);
export default new CollaborationGraphClient({
  serviceUrl: DEFAULT_CONFIG.collaborationGraphUrl
});